<template>
  <div>
    <v-form v-on:submit.prevent>
      <div
        style="margin-bottom: 24px"
      >Код подтверждения отправлен на номер {{maskedPhone}}. {{ currentTime > 0 ? 'Повторно запросить через ' + currentTime +'c.': ''}}</div>
      <v-text-field
        :error="errdesc.length > 0"
        :error-messages="errdesc"
        outlined
        autofocus
        label="Код из смс"
        v-mask="'####'"
        v-model="code"
        type="text"
      ></v-text-field>
    </v-form>
    <v-btn
      :disabled="currentTime > 0"
      x-large
      block
      color="primary"
      @click="refreshCode"
    >выслать код повторно</v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    module: {
      type: String,
      default: "registration",
    },
  },
  data() {
    return {
      currentTime: 180,
      timer: null,
    };
  },
  watch: {
    code(code, oldCode) {
      if (code.length === 4 && oldCode.length < 4) {
        this.confirm();
      }

      if (this.errdesc.length > 0) {
        this.clearErrdesc();
      }
    },

    currentTime(time) {
      if (time === 0) {
        this.stopTimer();
      }
    },
  },
  computed: {
    maskedPhone() {
      return this.$store.state[this.module].maskedPhone;
    },
    ...mapGetters("common", ["errdesc"]),
    code: {
      get() {
        return this.$store.state[this.module].code;
      },
      set(value) {
        this.$store.commit(this.module + "/setCode", value);
      },
    },
  },
  methods: {
    confirm() {
      this.$store.dispatch(this.module + "/confirm");
    },
    refresh() {
      this.$store.dispatch(this.module + "/refresh");
    },
    ...mapActions("common", ["clearErrdesc"]),
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--;
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timer);
    },

    async refreshCode() {
      this.currentTime = 180;
      await this.refresh();
      this.startTimer();
    },
  },
  mounted() {
    this.startTimer();
  },
  destroyed() {
    this.stopTimer();
    this.clearErrdesc();
  },
};
</script>
